import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './ChicletRow.module.scss';

interface Props {
  total: number;
  value: number;
  onChicletClick?: (value: number) => void;
}

function Chiclet({ active, onClick }: { active?: boolean; onClick?: VoidFunction }) {
  return <div onClick={onClick} className={classNames(styles.chiclet, { [styles.active]: active })} />;
}

export function ChicletRow({ total, value, onChicletClick }: Props) {
  const { t } = useTranslation();
  return (
    <div
      className={styles.chicletRow}
      role="group"
      aria-label={t('showing_item_out_of_total', { itemNumber: value + 1, total })}
    >
      {[...Array(total)].map((_, i) => (
        <Chiclet key={i} active={i === value} onClick={() => onChicletClick?.(i)} />
      ))}
    </div>
  );
}
